<template>
    <div id="DmhSlider" class="border-brand-secondary shadow">
        <div class="slider-text">{{ question.slider_text }}</div>
        <div class="slider-container border-brand-secondary">
            <div class="slider-row border-brand-tertiary position-relative">
                <button class="slider-button" :class="[option == selectedOption ? 'bg-brand-highlight-2' : 'bg-white']"
                    v-for="(option, index) in question.options" @click="selectOption(option)">
                    <span class="slider-index">{{index + 1}}</span>
                </button>
                <div class="line"></div>
            </div>
        </div>
        <div class="slider-answer brand-label">{{ selectedOption }}</div>
    </div>
</template>
<script>

export default {
    components: {

    },
    name: "Slider",
    data() {
        return {
            selectedOption: null,
        };
    },
    mounted() {
        this.selectedOption = this.question.options[2];
    },
    beforeDestroy() {

    },
    methods: {
        selectOption(option) {
            this.selectedOption = option;
            this.updateAnswer(this.question, option);
        },
    },
    props: ['question', 'updateAnswer', 'index'],
    inject: [],
    provide: function () {
        return {
            // alert : this.a
        }
    },
};
</script>
<style lang="less">
#DmhSlider {
    width: 100%;
    text-align: center;
    font-size: 1.8rem;
    margin-bottom: 70px;
    display: flex;
    flex: 1 1 0px;
    flex-direction: column;
    align-items: center;
    border-radius: 20px;
    padding: 20px;

    .slider-text {
        font-size: 1.6rem;
        margin-bottom: 16px;
        align-self: flex-start;
    }

    .slider-index {
        font-size: 1.4rem;
        font-family: "PlusJakartaSansBold";
        position: relative;
        top: 32px;
    }

    .slider-container {
        width: 100%;
        display: flex;
        flex: 1 1 0px;
        border-radius: 1000px;
        margin-bottom: 24px;
    }

    .slider-row {
        display: flex;
        flex: 1;
        flex-grow: 1;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        gap: 50px;

        .line {
            height: 16px;
            width: calc(100% - 3px);
            position: absolute;
            top: calc(50% - 8px);
            z-index: 3;
            border-radius: 20px;
            background-color: rgba(30, 30, 34, 0.05);
        }
    }

    .slider-button {
        cursor: pointer;
        width: 36px;
        height: 36px;
        border: 4px solid;
        border-color: #7E6CD8;
        border-radius: 100px;
        z-index: 5;
    }

    .slider-button.bg-brand-primary {
        border: none;
    }

    .slider-answer {
      font-family: "PlusJakartaSansBold";
        font-size: 1.6rem;
        margin-top: 20px;
        min-width: 250px;
    }

    .slider-answer::before {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid #DBDBDB;
    }

    @media only screen and (max-width: 992px) {
        .slider-row{
            gap: 20px;
        }
        .slider-button {
            width: 30px;
            height: 30px;
        }
    }
}</style>